import React from 'react';
import Navigation from './Navigation';
import ProfileHeader from './ProfileHeader';
// import MouseGlowEffect from '../MouseGlowEffect';

const Layout = ({ children, showTocButton = false, onToggleToc }) => {
  return (
    <div className="bg-white dark:bg-gray-900 leading-relaxed text-black dark:text-gray-400 antialiased selection:bg-gray-200 dark:selection:bg-blue-300 selection:text-black dark:selection:text-blue-900">
      {/* <MouseGlowEffect /> */}
      <div className="mx-auto min-h-screen max-w-screen-xl px-6 py-12 font-sans md:px-12">
        <Navigation showTocButton={showTocButton} onToggleToc={onToggleToc} />
        <ProfileHeader />
        <main className="w-full">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
